import React, { PureComponent, PropTypes } from 'react';
import { titleize } from '../../../../lib/strings';
import { Button } from '../../../shared';
import statsd from '../../../../lib/StatsD';
import './styles.scss';

/**
 * This bar shows on all pages when the current_user has entered their passcode.
 * the component relies on all user props aswell as admin and isClockedIn
 * booleans.
 * the current activitys actions.
 */
export class LoginBar extends PureComponent {
  /**
   * this method tests whether the current user is an device admin, and if so
   * shows admin controls
   * @return {Element} returns the admin controls
   */
  showContextControl() {
    const { currentUser } = this.props;
    if (currentUser.valid && currentUser.activities.length > 1) {
      return (
        <Button
          className='login-bar-button settingLabel'
          onClick={() => this.props.backwardActivity()}
        >
          <div className='row left'>
            <i className="fa fa-chevron-left fa-2x" aria-hidden="true" />
            <p>{titleize(currentUser.activities[1])}</p>
          </div>
        </Button>
      );
    }
    if (currentUser.valid) {
      return (
        <Button
          className='login-bar-button settingLabel'
          onClick={() => {
            statsd.increment('buttons.clear_user');
            return this.props.clearUser();
          }}
        >
          <div className='row left'>
            <i className="fa fa-chevron-left" aria-hidden="true" />
            <p>Keypad</p>
          </div>
        </Button>
      );
    }
    return null;
  }

  render() {
    const { currentUser } = this.props;
    return (
      <div className={`login-bar ${this.props.className}`}>

        {/**
         * the left side of the bar
         */}
        <div className='row left'>
          {this.showContextControl()}
        </div>

        {/**
         * the right side of the bar
         */}
        <div className='row right'>
          <p className='login-bar-user'>{currentUser.name}</p>
          <div className={`login-bar-status ${currentUser.clockedIn}`} />
        </div>
      </div>
    );
  }
}

LoginBar.propTypes = {
  clearUser: PropTypes.func,
  backwardActivity: PropTypes.func,
  currentUser: PropTypes.object,
  className: PropTypes.string,
};

export default LoginBar;



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/loginbar/main.jsx